/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Coins = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2 5V2H13V5.85177C12.1009 6.11122 11.2596 6.50711 10.5 7.01555V6.5H2.5V8H9.27503C8.80313 8.45205 8.38036 8.95499 8.01555 9.5H3.5V11H7.20591C7.00304 11.4802 6.84065 11.9816 6.72302 12.5H3.5V14H6.51365C6.50459 14.1655 6.5 14.3322 6.5 14.5C6.5 14.838 6.51863 15.1717 6.55493 15.5H4.5V17H6.85177C7.0021 17.521 7.19823 18.0225 7.43552 18.5H3.5V20H8.37555C8.80476 20.5552 9.29742 21.0588 9.84267 21.5H2V17H3V15.5H2V9.5H1V5H2ZM3.5 3.5H11.5V5H3.5V3.5Z"
                        fill={color}
                    />
                    <path
                        d="M15.7222 13.5426L15.4621 13.4526L15.3825 13.4242C15.008 13.2907 14.5714 13.1352 14.4221 12.8926C14.3221 12.7426 14.3721 12.4626 14.5121 12.3226C14.7021 12.1326 15.0522 12.0226 15.3822 12.0426C16.2822 12.0926 16.4422 12.6926 16.4722 12.9026L17.8822 12.4426C17.6922 11.6926 17.1321 10.9626 16.1821 10.6826V9.45264H14.6821V10.6226C14.2121 10.7226 13.7821 10.9326 13.4621 11.2626C12.8221 11.9026 12.6922 12.9426 13.1622 13.6926C13.6012 14.4011 14.3988 14.6715 14.9884 14.8714L14.9922 14.8726L15.2422 14.9626C15.9422 15.2126 16.4422 15.4126 16.5822 15.8626C16.6622 16.1026 16.6122 16.3626 16.4422 16.5826C16.2122 16.8826 15.8221 17.0326 15.3721 17.0126C14.8021 16.9726 14.3322 16.7526 13.7522 15.7726L13.6922 15.6726L12.3221 16.3026L12.4621 16.5326C12.9021 17.2726 13.5521 18.1226 14.6821 18.4126V19.4526H16.1821V18.4226C16.7621 18.2826 17.2822 17.9626 17.6422 17.4926C18.1122 16.8726 18.2521 16.0726 18.0121 15.3926C17.6621 14.2226 16.5122 13.8126 15.7422 13.5426H15.7222Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15.5 22C19.6421 22 23 18.6421 23 14.5C23 10.3579 19.6421 7 15.5 7C11.3579 7 8 10.3579 8 14.5C8 18.6421 11.3579 22 15.5 22ZM15.5 20.5C18.8137 20.5 21.5 17.8137 21.5 14.5C21.5 11.1863 18.8137 8.5 15.5 8.5C12.1863 8.5 9.5 11.1863 9.5 14.5C9.5 17.8137 12.1863 20.5 15.5 20.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
